import { Box, Typography, Grid2 } from '@mui/material'
import React from 'react'
import GiftCardComponent from '../CardComponent/CardComponent'

const MoreItems = ({ title, items = [], moreItems, children }) => {
  console.log("moreItems:", moreItems);
  
  return (
    <>
    {moreItems?.length === 0?
    <Box>
    </Box>:
    <Box>
        <Typography variant='h3' sx={{my:4, textTransform:'capitalize'}}>
            {title}    
        </Typography>
        
        <Grid2 container spacing={6} justifyContent={'flex-start'}  sx={{my:6}}>
           { moreItems?.map((item, index)=>{
                    return <Grid2 item xs={2} key={index} size={{ xs: 12, md: 4 }}>
                    <GiftCardComponent key={index} index={index} title={item?.name} description={item?.description} amount={item?.price} detailspath={`gift-details/${item.id}` } imageUrl={item?.imageUrl} />
                  </Grid2>
                })
              }
        </Grid2>
    </Box>
    }
    </>
  )
  
}

export default MoreItems